import { t } from '@/i18n';
import { z } from 'zod';

const ACCEPTED_IMAGE_TYPES = ['image/jpeg', 'image/jpg', 'image/png'];

export const modalFormSchema = z
  .object({
    title: z.string().min(1, t('pages.application_uniform_gallery.components.uniform_gallery_create_modal.schema.required')),
    season_uuid: z.string().min(1, t('pages.application_uniform_gallery.components.uniform_gallery_create_modal.schema.required')),
    team_uuid: z.string().optional(),
    credit: z.string().optional(),
    image: z
      .any()
      .refine(
        file => (file && ACCEPTED_IMAGE_TYPES.includes(file.type)) || !file,
        t('pages.application_uniform_gallery.components.uniform_gallery_create_modal.schema.required_file'),
      ),
  })
  .superRefine((values, ctx) => {
    if (!values.image) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['image'],
        message: t('pages.application_uniform_gallery.components.uniform_gallery_create_modal.schema.required_image'),
      });
    }
  });

export type ModalFormData = z.infer<typeof modalFormSchema>;
